import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Preferences } from '@capacitor/preferences';
import { Capacitor } from '@capacitor/core';
import { Router } from '@angular/router';
import { AuthResponseModel } from '../Models/Authentication/AuthResponse';


@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private token: string | null = null;
  private tokenKey             = 'authToken';
  private isWeb = Capacitor.getPlatform() === 'web';
  authResponse!            :AuthResponseModel;
  constructor
  (
    private jwtHelper: JwtHelperService,private router:Router
  ) 
  {
    this.loadToken(); 
  }

  isAuthenticated(): boolean {
    const token = this.getToken();
    return token ? !this.jwtHelper.isTokenExpired(token) : false;
  }

  private async loadToken(): Promise<void> {
    if (this.isWeb) {
      this.token = this.getCookie(this.tokenKey);
    } else {
      const { value } = await Preferences.get({ key: this.tokenKey });
      this.token = value || null;
    }
  }


  getToken(): string | null {
    return this.token;
  }

  public async saveToken(token: string): Promise<void> {
    this.token = token;
    if (this.isWeb) {
      this.setCookie(this.tokenKey, token, 7);
    } else {
      await Preferences.set({ key: this.tokenKey, value: token });
    }
  }

  getRoles(): string {
    let role = this.decodeTokenField("Role");
  
    // If Role claim is missing, check Microsoft claim format
    if (!role) {
      role = this.decodeTokenField("http://schemas.microsoft.com/ws/2008/06/identity/claims/role");
    }
  
    return role;
  }
  

  getUID(): string {
    return this.decodeTokenField('uid');
  }

  getLock(): string {
    return this.decodeTokenField('LockoutEnabled');
  }

  getLoggedEmail(): string {
    return this.decodeTokenField('Email');
  }

  getEmailStatus(): string {
    return this.decodeTokenField('EmailConfirmed');
  }

  getPaymentStatus(): string {
    return this.decodeTokenField('paid');
  }
  getEmailSetup(): string {
    return this.decodeTokenField('EmailSetup');
  }

  private decodeTokenField(field: string): string {
    const token = this.getToken();
    if (token) {
      const decodedToken = this.jwtHelper.decodeToken(token);
      return decodedToken[field] || '';
    }
    return '';
  }

  public async logout(): Promise<void> {
    this.token = null;
    if (this.isWeb) {
      this.deleteCookie(this.tokenKey);
    } else {
      await Preferences.remove({ key: this.tokenKey });
    }
    this.router.navigate(['/login']);
  }


  // Helper methods for cookie management
  private setCookie(name: string, value: string, days: number): void {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/`;
  }

  private getCookie(name: string): string | null {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
  }

  private deleteCookie(name: string): void {
    this.setCookie(name, '', -1);
  }


}
